import * as React from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import {
  Form, Icon, Input, Button
} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import {connect, GlobalProps} from '../../stores/GlobalStore';

import UserClient from '../../api/UserClient';
const userClient = UserClient();

import styles from './LoginForm.module.scss';
class LoginForm extends React.Component<{} & FormComponentProps & GlobalProps & RouteComponentProps<any>>{

  private handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const {tokens, firstname, _resultadosHolland, _resultadosJung} = await userClient.login({
          email: values.email,
          password: values.password
        }) as any;

        if(tokens){
          const [auth] = tokens;
          this.props.storeAuthToken(auth.token);
          this.props.setGlobalState({
            firstname, _resultadosHolland, _resultadosJung
          });
          return this.props.history.push('/');
        }

      }
    });
  }

  public render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className={styles.loginForm}>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Por favor, digite seu email' }],
          })(
            <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Por favor, digite sua senha' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Senha" />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Entrar
          </Button>
        </Form.Item>
        <Link to={'/cadastro'}>
          Faça seu cadastro
        </Link>
      </Form>
    );
  }

}

const WrappedLoginForm = Form.create({ name: 'normal_login' })(withRouter(LoginForm));

export default connect(WrappedLoginForm, 'authToken', 'storeAuthToken', 'setGlobalState');

